export default __webpack_public_path__ + "static/ontdek-autisme-2347a1bf3bbe456eebf3d900866a236e.png";